import { z } from 'zod';
import {
  AcademicYear,
  OrgId,
  UnixTimestamp,
  createBrandedString,
  createBrandedUuid,
  createBrandedUuidLoose,
  nowUnix,
} from '@triedge/domain-core/types';

export {
  AcademicYear,
  OrgId,
  UnixTimestamp,
  createBrandedString,
  createBrandedUuid,
  createBrandedUuidLoose,
  nowUnix,
};

export const FamilyId = createBrandedUuid('FamilyId');
export type FamilyId = z.infer<typeof FamilyId>;

export const StudentId = createBrandedUuid('StudentId');
export type StudentId = z.infer<typeof StudentId>;

export const ParentContactId = createBrandedUuid('ParentContactId');
export type ParentContactId = z.infer<typeof ParentContactId>;

export const StudentDocumentId = createBrandedUuid('StudentDocumentId');
export type StudentDocumentId = z.infer<typeof StudentDocumentId>;

export const AcademicRecordId = createBrandedUuid('AcademicRecordId');
export type AcademicRecordId = z.infer<typeof AcademicRecordId>;

export const FamilyInteractionId = createBrandedUuid('FamilyInteractionId');
export type FamilyInteractionId = z.infer<typeof FamilyInteractionId>;

export const CommunicationId = createBrandedUuid('CommunicationId');
export type CommunicationId = z.infer<typeof CommunicationId>;

export const FamilyAccountTransactionId = createBrandedUuid('FamilyAccountTransactionId');
export type FamilyAccountTransactionId = z.infer<typeof FamilyAccountTransactionId>;

export const AdHocInvoiceId = createBrandedUuid('AdHocInvoiceId');
export type AdHocInvoiceId = z.infer<typeof AdHocInvoiceId>;

export const BulkChargeJobId = createBrandedUuid('BulkChargeJobId');
export type BulkChargeJobId = z.infer<typeof BulkChargeJobId>;

export const RecurringFeeDefinitionId = createBrandedUuid('RecurringFeeDefinitionId');
export type RecurringFeeDefinitionId = z.infer<typeof RecurringFeeDefinitionId>;

export const RecurringFeeAssignmentId = createBrandedUuid('RecurringFeeAssignmentId');
export type RecurringFeeAssignmentId = z.infer<typeof RecurringFeeAssignmentId>;

export const FamilyPaymentMethodId = createBrandedUuid('FamilyPaymentMethodId');
export type FamilyPaymentMethodId = z.infer<typeof FamilyPaymentMethodId>;

export const ActivityLogId = createBrandedUuid('ActivityLogId');
export type ActivityLogId = z.infer<typeof ActivityLogId>;

export const UserId = createBrandedUuidLoose('UserId');
export type UserId = z.infer<typeof UserId>;

export const ResourceId = createBrandedString('ResourceId');
export type ResourceId = z.infer<typeof ResourceId>;

export const ApplicantId = createBrandedUuidLoose('ApplicantId');
export type ApplicantId = z.infer<typeof ApplicantId>;

export const ChildApplicationId = createBrandedUuidLoose('ChildApplicationId');
export type ChildApplicationId = z.infer<typeof ChildApplicationId>;
